import { React, PT, connect } from '@gasbuddy/react';
import { Container, Form, Button } from 'semantic-ui-react';
import { VerticalCenter } from '../../components/vertical-center';
import { LoginStatus } from '../../components/auth';

const LogoutPageComponent = ({ auth }) => {
  if (auth.status === LoginStatus.LoggedOut) {
    return (
      <VerticalCenter>
        <Container text>
          <h1>You have been logged out.</h1>
        </Container>
      </VerticalCenter>
    );
  }
  return (
    <VerticalCenter>
      <Form method="POST">
        <Button>Logout</Button>
      </Form>
    </VerticalCenter>
  );
};

LogoutPageComponent.propTypes = {
  auth: PT.shape({
    status: PT.number,
  }).isRequired,
};

export default connect(({ auth }) => auth)(LogoutPageComponent);
